import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.jpg";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/intro-photo.png";
// import userCreditHref from './assets/userCreditHref.png'

//TODO: EVENT_ID
const EVENT_ID = "s0002";

//TODO: aboutWalkContent
const aboutWalkContent = `橫越屏東縣春日鄉和臺東縣大武鄉的浸水營古道，始於1885年開鑿，自水底寮進抵大武，全長約64公里，海拔均高1,000公尺，為當時臺灣東、西部往返的重要道路，據傳平埔族人曾經藉此遷移至東部地區。日治時期，浸水營古道因低海拔和距離短的條件，被臺灣總督府用於連接東、西部的電信郵遞，直到1914年發生「南蕃事件」，致使道路中斷數年。最後，整條浸水營古道的復舊工事於1917年完成，同時增設了大樹林駐在所與古里巴保諾駐在所。`;

const credit = `
本平臺由智紳數位文化事業有限公司建置，並提供原住民族委員會原住民族文化發展中心使用，原住民族委員會原住民族文化發展中心保有地圖內容著作財產權。若有其他利用或授權需求請洽【智紳數位文化事業】Facebook粉絲專頁。
`;

// const creditHref = 'https://www.facebook.com/JRSHENDigitalCulture/'

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "橫越屏東縣春日鄉和",
  sidebarSubtitle: "臺東縣大武鄉的浸水營古道",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "屏東縣", town: "枋寮鄉" },
      { county: "屏東縣", town: "春日鄉" },
      { county: "臺東縣", town: "達仁鄉" },
      { county: "臺東縣", town: "大武鄉" },
    ], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#C05A2D", //TODO: theme
    "--dui-accent": "#be0b1c", //TODO: 數位集章按鈕顏色
    "--dui-secondary": "#C05A2D", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#EAC58D", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      //! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="數位集章"
      //     active={dui.activeMenuId === '數位集章'}
      //     {...dui.menuSwitcherAction('數位集章')}
      //   >
      //     {dui.activeMenuId === '數位集章' && (
      //       <iframe
      //         title="數位集章"
      //         style={{ height: '100%', border: 0, borderRadius: '5px' }}
      //         src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //       ></iframe>
      //     )}
      //     {/* {paths.map(path => (
      //       <div
      //         key={path.name}
      //         style={{
      //           display: "flex",
      //           alignItems: "center",
      //           margin: "20px",
      //         }}
      //       >
      //         <div
      //           style={{
      //             width: "50px",
      //             height: "5px",
      //             backgroundColor: path.color,
      //             alignItems: "center",
      //             marginRight: "10px",
      //           }}
      //         ></div>
      //         <span
      //           style={{
      //             fontSize: "20px",
      //             color: "#000",
      //             // fontWeight: "bold",
      //           }}
      //         >{` ：${path.name}`}</span>
      //       </div>
      //     ))} */}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(22.416365603585042, 120.56481062594798),
        latLng(22.33196911918108, 120.93047126704629),
      ),
      maxZoom: 20,
    }),
  );

  useEffect(() => {
    // TODO(maybe): userCreditHref
    // const creditElem = document.getElementsByClassName(
    //   'dui-CreditDialogContent'
    // )[0]
    // const finalBlock = creditElem.querySelector('.final')
    // const createLogo = (src: string) => {
    //   const logo = new Image()
    //   logo.src = src
    //   logo.style.height = '57px'
    //   return logo
    // }
    // finalBlock?.appendChild(createLogo(userCreditHref))
  }, []);

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider Jsdc={Jsdc} config={config}>
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
